module.exports = __webpack_public_path__ + "img/discount.53c82d43.svg";